/**
 * Extracts a human-readable error message from an API Response.
 * Handles ASP.NET Core ModelState responses, ProblemDetails, and plain text.
 */
export default async function extractErrorMessage(response: Response): Promise<string> {
    try {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const data: any = await response.json();
            if (typeof data === "string") {
                return data;
            }
            if (data.title) {
                return data.title;
            }
            if (data.errors) {
                const errorMessages: string[] = [];
                Object.keys(data.errors).forEach((key: string) => {
                    const value = data.errors[key];
                    if (Array.isArray(value)) {
                        value.forEach((message: string) => errorMessages.push(message));
                    }
                });
                return errorMessages.join("; ") || "An error occurred.";
            }
            return JSON.stringify(data);
        }
        return await response.text() || "An error occurred.";
    } catch (e) {
        return "An error occurred.";
    }
}



// WEBPACK FOOTER //
// ./ClientApp/utils/extractErrorMessage.ts